import React, { useMemo, useState } from "react";
import moment from "moment";
import { Col, Form, Row } from "react-bootstrap";
import { CONFIG } from "../../Constants/storageConstant";
import * as stringConstants from "../../Constants/stringConstants";
import { MAX_50_CHARS, MAX_QTY_LIMIT_REACHED } from "../../Constants/stringConstants";
import * as apiHelper from "../../Services/ApiHelper";
import { getLocalData } from "../../Services/common";
import { isNullOrEmpty } from "../../Utils/stringUtils";
import { success, warn } from "../../Wrapper/toast/toast";
import Input from "../_widgets/Input/Input";
import BasicModal from "../_widgets/Modal/BasicModal";
import MultiMobileModal from "../Patients/PatientVisits/MultiMobileModal";

const AddConsumeModal = ({
  modalShow,
  setModalShow,
  handleClose,
  addInventoryData,
  addInventory,
  buttonLoading,
  setAddInventoryData,
}) => {
  const [multiMobileModal, setMultiMobileModal] = useState(false);
  const [patientData, setPatientData] = useState([]);
  const configs = useMemo(() => getLocalData(CONFIG), []);

  const searchPatient = async (query, fieldName) => {
    // Indicate search start
    setAddInventoryData((prev) => ({
      ...prev,
      searchingPatient: fieldName,
    }));

    apiHelper.searchPatient(`?query=${query}`).then((response) => {
      if (response?.isSuccess) {
        if (!isNullOrEmpty(response.data)) {
          success(stringConstants.PATIENT_FOUND);

          let suggestionSelect = Array.isArray(configs)
            ? configs.find((i) => i.key === "patient_suggestion_option_dropdown")?.value
            : undefined;

          if (response.data.length > 1 || suggestionSelect === "suggestion") {
            setPatientData(response.data);
            setMultiMobileModal(true);
          } else {
            const { id, name } = response.data[0];

            // ✅ Update patient info safely
            setAddInventoryData((prev) => ({
              ...prev,
              patient_id: id,
              patient_name: name,
            }));
          }
        } else {
          warn(stringConstants.PATIENT_NOT_FOUND);
        }

        // ✅ Update the searching flag safely — this was overwriting before
        setAddInventoryData((prev) => ({
          ...prev,
          searchingPatient: false,
        }));
      }
    });
  };

  const handleCloseMobileModal = () => {
    setMultiMobileModal(false);
  };

  const handleNumberSelection = (data) => {
    const { id, name } = data;
    setAddInventoryData((prevState) => ({
      ...prevState,
      patient_id: id,
      patient_name: name,
    }));
    setMultiMobileModal(false);
  };
  return (
    <BasicModal
      show={modalShow}
      size="lg"
      setModalShow={setModalShow}
      handleClose={handleClose}
      heading={`Consume Stock for ${addInventoryData?.name}`}
      footer
      button2Text="Save"
      button2Click={() => addInventory()}
      loading={buttonLoading}
    >
      <MultiMobileModal
        modalShow={multiMobileModal}
        setModalShow={setMultiMobileModal}
        handleClose={handleCloseMobileModal}
        data={patientData}
        handleNumberSelection={handleNumberSelection}
        createNewPatient={null}
      />
      <div className="patients_ui">
        <Row>
          <Col xl={12}>
            <div className="white_card text-start">
              <Row className="mb-3">
                <Col lg={6}>
                  <Input
                    isRequired={true}
                    placeholder="Enter Quantity"
                    type="number"
                    label="Quantity"
                    step="0.25"
                    min="0.25"
                    value={addInventoryData?.qty}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value > 99999) {
                        warn(MAX_QTY_LIMIT_REACHED);
                      } else {
                        let val = parseFloat(e.target.value);

                        if (isNaN(val)) {
                          setAddInventoryData({ ...addInventoryData, qty: "" });
                          return;
                        }

                        // Round to nearest 0.25
                        val = Math.round(val * 4) / 4;

                        // Ensure minimum value is 0.25
                        if (val < 0.25) val = 0.25;

                        setAddInventoryData({ ...addInventoryData, qty: val });
                      }
                    }}
                  />
                </Col>

                <Col lg={6}>
                  <Input
                    isRequired={true}
                    type="datetime-local"
                    label="Date"
                    max={moment().format("YYYY-MM-DDTHH:mm")}
                    value={addInventoryData.date}
                    onChange={(e) => {
                      setAddInventoryData({
                        ...addInventoryData,
                        date: e.target.value,
                      });
                    }}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Col lg={6}>
                  <Input
                    // isRequired={true}
                    placeholder="Remarks"
                    type="text"
                    label="Remarks"
                    value={addInventoryData.remarks}
                    onChange={(e) => {
                      if (e.target.value.length <= 50) {
                        setAddInventoryData({
                          ...addInventoryData,
                          remarks: e.target.value,
                        });
                      } else {
                        warn(MAX_50_CHARS);
                      }
                    }}
                  />
                </Col>

                <Col lg={6}>
                  <Input
                    placeholder="Enter Patient Name"
                    type="text"
                    label="Patient Name"
                    style={{ textTransform: "uppercase" }}
                    suffixIcon="search"
                    iconTooltip={"Search"}
                    showLoaderIcon={addInventoryData?.searchingPatient === "patientName"}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        if (addInventoryData.patient_name.length < 2) {
                          warn(stringConstants.minimumLengthRequired(2));
                        } else {
                          searchPatient(addInventoryData.patient_name, "patientName");
                        }
                      }
                    }}
                    onClickIconSuff={() => {
                      if (addInventoryData.patient_name.length < 2) {
                        warn(stringConstants.minimumLengthRequired(2));
                      } else {
                        searchPatient(addInventoryData.patient_name, "patientName");
                      }
                    }}
                    value={addInventoryData.patient_name ?? ""}
                    onChange={(e) => {
                      if (e.target.value.length <= 30) {
                        setAddInventoryData({
                          ...addInventoryData,
                          patient_name: e.target.value,
                        });
                      } else {
                        warn(stringConstants.MAX_30_CHARS);
                      }
                    }}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </BasicModal>
  );
};

export default AddConsumeModal;
